import { Component } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router, RouterModule } from '@angular/router';
import { environment } from '../../environments/environment';
import { AlertService } from '../../service/alert.service';
import { MatIcon } from "@angular/material/icon";
import { AlertMessageComponent } from "../../shared/alert-message/alert-message.component";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-resend-mail-verification',
  standalone: true,
  templateUrl: './resend-mail-verification.component.html',
  styleUrl: './resend-mail-verification.component.css',
  imports: [MatIcon, AlertMessageComponent, FormsModule, MatProgressSpinner, CommonModule,RouterModule, TranslateModule]
})
export class ResendMailVerificationComponent {

  email: string = '';
  isLoading: boolean = false;

  constructor(private http: HttpClient, private alertService: AlertService, private router: Router) {}

  resendMail(form: NgForm) {
    // Clear previous alerts
    this.alertService.clear();

    // Validate email
    if (!this.email || this.email.trim() === '') {
      this.alertService.errorKey('auth.errors.email-required');
      return;
    }

    // Basic email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(this.email.trim())) {
      this.alertService.errorKey('auth.errors.invalid-email');
      return;
    }

    this.isLoading = true;
    const payload = { email: this.email.trim() };

    this.http.post<any>(
      `${environment.apiUrl}/api/auth/resend`,
      payload,
      { responseType: 'text' as 'json' }
    ).subscribe({
      next: () => {
        this.isLoading = false;
        this.alertService.successKey('auth.resend.success', true);
        this.router.navigate(['/login']);
      },
      error: (err) => {
        this.isLoading = false;
        const errorMessage = err.error;
        const errorKey = this.translateResendErrorKey(errorMessage);

        this.alertService.errorKey(errorKey || 'auth.errors.generic');
      }
    });
  }

  private translateResendErrorKey(errorMessage: unknown): string {
    if (typeof errorMessage !== 'string') {
      return '';
    }

    const normalizedMessage = errorMessage.toLowerCase();

    if (
      normalizedMessage.includes('non esiste') ||
      normalizedMessage.includes('not found') ||
      normalizedMessage.includes('account')
    ) {
      return 'auth.resend.errors.no-account';
    }

    if (
      normalizedMessage.includes('gi? verificata') ||
      normalizedMessage.includes('gia verificata') ||
      normalizedMessage.includes('already verified')
    ) {
      return 'auth.resend.errors.already-verified';
    }

    return '';
  }

}
